package org.braunequip.web.styles

import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.css.functions.toImage
import com.varabyte.kobweb.compose.css.functions.url
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.braunequip.web.util.Constants
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.AlignItems

/*
    Trucking Hero Section
*/
val truckingHeroBg = CssStyle {
    base {
        Modifier
            .background(
                Background.of(
                    image = BackgroundImage.of(url("generictruck.jpg")),
                    position = BackgroundPosition.of(CSSPosition.Center),
                    size = BackgroundSize.Cover,
                ),
                Background.of(image = linearGradient(Color.rgba(0, 0, 0, 0.5f), Color.rgba(0, 0, 0, 0.5f)).toImage())
            )
    }
}

/*
    Description Section
*/


val servicesContainer = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .display(DisplayStyle.Flex)
            .flexDirection(FlexDirection.Column)
            .fontFamily(Constants.FONT_FAMILY2)
    }
    Breakpoint.MD {
        Modifier
            .flexDirection(FlexDirection.Row)
            .justifyContent(JustifyContent.SpaceBetween)
            .alignItems(AlignItems.Center)
    }
}

val servicesBlock = CssStyle {
    base {
        Modifier
            .display(DisplayStyle.Flex)
            .flexDirection(FlexDirection.Column)
            .justifyContent(JustifyContent.Center)
            .alignItems(AlignItems.Center)
            .textAlign(TextAlign.Center)
            .textOverflow(TextOverflow.Ellipsis)
            .flexBasis(25.percent)

            .color(Colors.White)
            .fontSize(16.px)
            .fontWeight(FontWeight.Light)

            //Some better spacing vertically on mobile
            .gap(10.px)
            .margin(topBottom = 5.px)
    }
    Breakpoint.MD {
        Modifier
            .fontSize(24.px)
    }
}
